export const SQLSCRIPTEXECUTED_SHOW_RESET = 'SQLSCRIPTEXECUTED_SHOW_RESET'
export const SQLSCRIPTEXECUTED_SHOW_SET_ERROR = 'SQLSCRIPTEXECUTED_SHOW_SET_ERROR'
export const SQLSCRIPTEXECUTED_SHOW_SET_RETRIEVED = 'SQLSCRIPTEXECUTED_SHOW_SET_RETRIEVED'
export const SQLSCRIPTEXECUTED_SHOW_TOGGLE_LOADING = 'SQLSCRIPTEXECUTED_SHOW_TOGGLE_LOADING'
